<template>
  <div class="video-section">
    <vue-plyr>
      <video
          autoplay
          crossorigin
          playsinline
          loop
          class="video-section__video"
      >
        <source
            size="1080"
            src="botlar.MP4"
            type="video/mp4"
        />
      </video>
    </vue-plyr>
    <button class="go-button mobile-button" @click="go">
      <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5674 14.0164L13.568 14.0149L13.582 13.9775L16 0.968767V0.926513C16 0.602392 15.8878 0.319435 15.6435 0.14971C15.4298 0.00114806 15.184 -0.00943204 15.0117 0.00452444C14.8295 0.0192848 14.6576 0.0678257 14.5387 0.108231C14.4775 0.129019 14.4262 0.149048 14.3896 0.164197C14.3712 0.1718 14.3563 0.178252 14.3455 0.183059L14.3348 0.18784L0.853127 5.83127L0.849417 5.83269C0.842135 5.83552 0.832506 5.83935 0.820876 5.84418C0.797691 5.85381 0.766131 5.86759 0.729056 5.88553C0.65626 5.92073 0.555681 5.97506 0.453678 6.0496C0.280435 6.17619 -0.0494461 6.47589 0.00625703 6.95104C0.0523959 7.3446 0.306635 7.59455 0.478036 7.72396C0.569916 7.79334 0.657816 7.84336 0.722184 7.87606C0.754799 7.89263 0.782503 7.90532 0.803134 7.91428C0.813479 7.91878 0.822127 7.92237 0.828819 7.92508L0.837387 7.92849L0.842864 7.93066L3.20158 8.77801C3.19362 8.93592 3.20829 9.09694 3.24754 9.2558L4.42905 14.0384C4.56913 14.6054 5.04989 15.0004 5.59946 15C6.09207 14.9996 6.52897 14.6816 6.71457 14.2072L8.5592 12.1025L11.7273 14.6943L11.7723 14.7153C12.0601 14.8493 12.3291 14.8918 12.5749 14.8559C12.8205 14.8201 13.0156 14.7103 13.1621 14.5852C13.3063 14.462 13.4052 14.3231 13.4673 14.2184C13.4989 14.1653 13.5225 14.1186 13.5388 14.0834C13.547 14.0658 13.5535 14.0508 13.5583 14.0392L13.5644 14.0242L13.5665 14.0187L13.5674 14.0164ZM4.41704 8.9268C4.39019 8.81811 4.43235 8.70336 4.52127 8.6431L12.5217 3.22168C12.5217 3.22168 12.9923 2.91684 12.9755 3.22168C12.9755 3.22168 13.0594 3.27552 12.8073 3.52652C12.5681 3.76492 7.10516 9.39297 6.55239 9.96247C6.52048 9.99534 6.50144 10.0331 6.49019 10.0788L5.59855 13.7094L4.41704 8.9268Z" fill="white"/>
      </svg>
      <span @click="go">
        Telegrama keç
      </span>
    </button>
  </div>
</template>
<script>

export default {
  methods: {
    go(){
      console.log('clicked');
      window.location.href = "https://t.me/botlar_az_bot";
    }
  }
}
</script>
<style lang="scss" scoped>

</style>